module.exports = __webpack_public_path__ + "static/img/Deyubg_03.d702d5d6.jpg";